import React from 'react';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';
import useCreateAddress, {
  CreateAddressProps,
} from 'modules/addresses/hooks/use-create-address';
import {translatedAddressProps} from 'modules/addresses/types';

const CreateAddress: React.FC = () => {
  const {getInput, getAddressInput} = useFormInputs<CreateAddressProps>();

  const handleSubmit = ({name, address}: CreateAddressProps) => {
    return {
      name,
      ...address,
    };
  };

  return (
    <Creation<CreateAddressProps>
      titleBar={{title: 'Cadastrar endereço'}}
      onSubmit={useCreateAddress}
      handleSubmit={handleSubmit}
      inputs={[
        getInput({
          name: 'name',
        }),
        getAddressInput({
          label: 'Endereço',
          name: 'address',
          confirmCoordinates: true,
        }),
      ]}
      translationKey={translatedAddressProps}
    />
  );
};

export default CreateAddress;
